import { ApiClient } from '../../../api/ApiClient';
import { v2 } from '../../../api/ApiInterfaceV2';
import { Arr } from '../../../CodesForFoundation';
import { AppEvents } from '../../AppEvents';
import { ProfileModel } from '../../ProfileModel';
import { createScope } from '../../Scope';
import { NavigationModel } from './NavigationModel';

export const NavigationScope = createScope({
    traceAs: 'NavigationScope',
    shouldRefresh() {
        return false;
    },
    async refresh(p, c) {

        const api = c.get(ApiClient);
        const evts = c.get(AppEvents);
        const me = c.get(ProfileModel);

        const data = await api.exec(v2.me.home());
        const [model, updateModel] = NavigationModel.create(data);
        // await waitFor(3000);

        c.bind(NavigationModel).toConstantValue(model);

        return [
            //
            // Workspace updates
            evts.on('workspace:patch', ({ workspace }) => updateModel(({ workspaces }) => {
                Object.assign(workspaces.find(x => x.id === workspace.id) ?? {}, workspace);
            })),
            evts.on('workspace:delete', ({ workspaceId }) => updateModel(({ workspaces }) => {
                Arr.removeWhere(workspaces, x => x.id === workspaceId);
            })),
            evts.on('workspace:members:add', ({ user, workspace }) => updateModel(({ workspaces }) => {
                if (user.id === me.id) {
                    workspaces.push(workspace);
                }
            })),
            evts.on('workspace:members:remove', ({ userId, workspaceId }) => updateModel(({ workspaces }) => {
                if (userId === me.id) {
                    Arr.removeWhere(workspaces, x => x.id === workspaceId);
                }
            })),
            //
            // Folder updates
            evts.on('folder:create', ({ folder }) => updateModel(({ workspaces }) => {
                const w = workspaces.find(x => x.id === folder.workspaceId);
                Arr.addIfNotMatch(w?.folders ?? [], folder, x => x.id === folder.id);
            })),
            evts.on('folder:patch', ({ folder }) => updateModel(({ workspaces }) => {
                const w = workspaces.find(x => x.id === folder.workspaceId);
                const f = w?.folders?.find(x => x.id === folder.id);
                if (f) Object.assign(f, folder);
            })),
            evts.on('folder:delete', ({ folderId }) => updateModel(({ workspaces }) => {
                for (const w of workspaces) {
                    Arr.removeWhere(w.folders, x => x.id === folderId);
                }
            })),
        ];
    }
});
